// extracted by mini-css-extract-plugin
export default {"wrapper":"ws_wrapper__HGiuJ","content":"ws_content__Jm2x4"};